import { getDirectusToken } from '../../../utils/localStorage';
import { loginDirectus } from './login';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;
const TARIFF_COLLECTION = process.env.REACT_APP_DIRECTUS_USER_ELECTRICITY_TARIFF_COLLECTION || 'user_electricity_tariff';

async function fetchWithAuth(url, options = {}, { user, password, signal } = {}) {
  let token = getDirectusToken();
  if (!token && user && password) {
    token = await loginDirectus(user, password);
  }
  let response = await fetch(url, {
    ...options,
    headers: { ...options.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    signal
  });
  if (response.status === 401 && user && password) {
    token = await loginDirectus(user, password);
    response = await fetch(url, {
      ...options,
      headers: { ...options.headers, ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      signal
    });
  }
  return response;
}

export async function getUserElectricityTariffs({ orgUnit, signal, user, password } = {}) {
  if (!DIRECTUS_URL) throw new Error('REACT_APP_DIRECTUS_URL fehlt.');
  const params = new URLSearchParams({
    sort: '-valid_from',
    fields: [
      'id',
      'provider',
      'is_dynamic_tariff',
      'valid_from',
      'valid_to',
      'price_per_kwh',
      'org_unit'
    ].join(',')
  });
  if (orgUnit != null && orgUnit !== '') {
    params.set('filter[org_unit][_eq]', orgUnit);
  }
  const url = `${DIRECTUS_URL.replace(/\/$/, '')}/items/${TARIFF_COLLECTION}?${params.toString()}`;
  const response = await fetchWithAuth(url, {}, { user, password, signal });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`Directus user_electricity_tariff: ${response.status} ${text}`);
  }
  const payload = await response.json();
  return Array.isArray(payload?.data) ? payload.data : [];
}
